import { render, staticRenderFns } from "./exam-statistic.vue?vue&type=template&id=1cc33d41&scoped=true&"
import script from "./exam-statistic.vue?vue&type=script&lang=ts&"
export * from "./exam-statistic.vue?vue&type=script&lang=ts&"
import style0 from "./exam-statistic.vue?vue&type=style&index=0&id=1cc33d41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc33d41",
  null
  
)

export default component.exports